import Cookies from 'js-cookie'
import React, {useState, useEffect, useRef} from 'react'
import sia, {IMG_DIR} from '../services/Api'
import LoaderView from '../tools/LoaderView'
import TopNav from './TopNav'

function DeadList(props) {

    const [deadList, setDeadList] = useState()
    const [isLoading, setLoading] = useState(true)
    const [selectedDead, setSelectedDead] = useState(true)
    const seachToServer = useRef('')

    const selectedCityId = useRef(null)
    const deadCode = useRef(null)
    const deadName = useRef(null)
    const isMine = useRef(false)

    useEffect(() => {
        const search = props.location.search
        const params = new URLSearchParams(search)
        selectedCityId.current = params.get('city')
        deadCode.current = params.get('d-code')
        deadName.current = params.get('d-name')
        isMine.current = params.get('mine')
        seachToServer.current = params.get('s') ?? ''
        getData()
    }, [])

    const getData = async () => {
        setDeadList([])
        var route = ''
        if (seachToServer.current.length > 0) {
            route = 'dead?search=' + seachToServer.current
        } else if (!isMine.current) {
            route = 'dead?' + (selectedCityId.current ? 'city_id=' + selectedCityId.current : '') + (deadCode.current || deadName.current ? ('search=' + (deadCode.current ?? (deadName.current ?? ''))) : '')
        } else {
            route = 'myDead?my_archive=1' + (seachToServer.current.length > 0 ? ('&search=' + seachToServer.current) : '')
        }
        setLoading(true)
        await sia.getDataFromServer(route).then((response) => {
            if (response.status == 200) {
                setDeadList(response.data)
            }
        }).catch((err) => console.log(err))
        setLoading(false)
    }

    const deleteDead = async (id) => {
        await sia.PostDataToServer("dead/destroy/" + id).then((response) => {
            if (response.status == 200) {
                window.location.reload(true);
            }
        }).catch((err) => console.log(err))
    }

    const editDead = async (id) => {
        window.location.reload(true);
    }

    return (
        <div>
            <header>
                <div className="pagewrapper slim1" id="header-slim">
                    <div className="container">
                        <TopNav/>
                    </div>
                </div>
            </header>
            <div className="clear"/>
            <div className="pagewrapper" id="center-search">
                <div className="container">
                    <form action id="center-search-form">
                        <input type="text" name="mc" placeholder="کد متوفی را جستجو کنید"
                               onChange={(e) => seachToServer.current = e.target.value}
                               className="text radius50 box-sizing"/>
                        <input value="جستجو" onClick={() => getData()} className="btn ease radius50"/>
                    </form>
                    <a className="clickable" href={localStorage.getItem('token') ? './add-motevafa' : './login'} title
                       className="link-btn ease box-sizing radius50">{localStorage.getItem('token') ? 'ثبت یادبود' : 'ورود و ثبت نام رایگان صفحه یادبود'}</a>
                </div>
            </div>
            {isLoading ? <LoaderView/> : <div className="pagewrapper" id="motevafa-list">
                <div className="container">
                    <h2 className="main-title">{isMine.current ? 'یادبودهای من' : 'لیست متوفی ها'}</h2>
                    <ul className="list-items people">
                        {deadList.map((item) => <li className="item clickable">
                            <a href={"./motevafa/" + item._id} title className="ease box-sizing radius10">
                                <img src={IMG_DIR + item.picture} alt="" className="radius10" width={40} height={40}/>
                                <span>{item.name} ({item.record_id})</span>
                            </a>
                            {isMine.current ?
                                <div className="edit-delete radius50" style={{
                                    marginTop: '5px',
                                }}>
                                    <button className="link-btn ease box-sizing radius50" style={{
                                        background: '#363636',
                                    }}>
                                        <a href={"/edit-motevafa/" + item._id} style={{
                                            display: 'inline',
                                        }}>ویرایش</a>
                                    </button>

                                    <button className="link-btn ease box-sizing radius50" style={{
                                        background: '#363636',
                                    }}>
                                        <a onClick={() => deleteDead(item._id)} style={{
                                            display: 'inline',
                                        }}>حذف</a>
                                    </button>

                                </div>

                                : ''}
                        </li>)}
                    </ul>
                </div>
            </div>}
            <div className="clear"/>
            <footer>
                <div className="pagewrapper" id="footer">
                    <div className="container box-sizing">
                        <div className="copyright">
                            <a href="#" title><img src="assets/images/logo.svg" alt="" className="logo" width={57}
                                                   height={57}/></a>
                            طراحی و توسعه و بهینه سازی توسط <a href="https://wwwebsite.ir/" title="وب سایت پارسی">وب
                            سایت پارسی</a>
                        </div>
                        <a href title><img src="assets/images/enamad.png" alt="" className="certificate" width={89}
                                           height={89}/></a>
                        <a href title><img src="assets/images/samandehi.png" alt="" className="certificate" width={89}
                                           height={89}/></a>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default DeadList
